module.exports = __webpack_public_path__ + "static/img/logo.09cb0559.png";